import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        const userSessionKey = 'wa360_session';
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const getTopLevelDomain = (domain) => {
            // this should return only the
            // extension and the top level of the domain
            // ex: futurewalottery.com
            // from stg01.mylottery360.futurewalottery.com
            return domain.split('.').slice(-2).join('.');
        };

        const setCookieValueByName = (cookieName, cookieValue) => {
            if (typeof document === 'undefined') {
                return;
            }

            document.cookie = `${cookieName}=${cookieValue}; Path=/; Domain=${getTopLevelDomain(document.location.hostname)}`;
            return cookieValue;
        };

        let result = await apiClient(config).apiMethod({
            method: 'PlayerLoginWithPTA',
            args: {
                hash: payload.hash,
                email: payload.email,
                password: payload.password,
                login_type: 'desktop',
                remember: true,
                pta_version: payload.pta_version,
            },
        });

        let player = result.player;
        let loggedIn = player ? true : false;
        if (loggedIn) {
            setCookieValueByName(appCookieKey, result.token);
            let cookie = JSON.stringify({
                token: result.token,
                spat: result.spat,
                password_expiration_days: result.password_expiration_days,
                expires: result.password_expiration_days,
            });
            setCookieValueByName(sharedCookieKey, cookie);
            return {
                loggedIn: loggedIn,
                player: {
                    registrar_id: player.registrar_id,
                    name: player.firstname + ' ' + player.lastname,
                    email: player.email,
                    firstname: player.firstname,
                    first_name: player.firstname,
                    lastname: player.lastname,
                    last_name: player.lastname,
                    email_confirm: player.email,
                    account_type: player.account_type,
                    actions: player.actions,
                    address: player.address,
                    birthday: player.birthdate,
                    birthdate: player.birthdate,
                    extra: player.extra,
                    phone: player.phone,
                },
                password_expiration_days: result.password_expiration_days,
            };
        } else if (result.code) {
            return {
                loggedIn: false,
                errors: result.code,
                message: result.message,
                data: result.data,
            };
        } else {
            return {
                loggedIn: false,
                errors: 'Unspecified Error',
            };
        }
    };
};
